export default __webpack_public_path__ + "static/media/07AW2AUG66.76d9f9ef.jpg";